import { NgxBadgeMode, NgxBadgeStatus } from '@digipay/ngx-badge/lib/ngx-badge.type';
import { Action } from '@client-monorepo/common/action-handler';

export type ItemOverview = {
  image: ServiceImage;
  title: string;
  badge?: ServiceBadge;
  subTitleNormal?: string;
  subTitleBold?: string;
  divider?: boolean;
  action?: Action;
  score?: Score;
};

type ServiceImage = {
  type: ServiceImagesType; // logo or icon
  name: string;
  color?: string;
};

export type ServiceBadge = {
  text: string;
  status: NgxBadgeStatus;
  mode: NgxBadgeMode;
};

export type SelectedSectionHeader = {
  image: string;
  title?: string;
  subTitle?: string;
  imageType?: ServiceImagesType;
};

export enum ServiceImagesType {
  IMAGE_ID = 'IMAGE_ID',
  ICON = 'ICON',
  SRC = 'SRC',
}

export type Score = {
  amount: number;
  count: number;
};
